import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { addCollateral } from 'api/operations/productServiceV2';
import { uploadFiles } from 'global/utils/uploadFiles';
import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';

interface UploadFileFormFields extends DefaultFormFields {
  name: FormControl<string>;
}

export default class UploadFileModalStore {
  rootStore: RootStore;
  loading = false;
  showUploadFileModal = false;
  isFileUploadReset = false;
  uploadFileForm: FormController<UploadFileFormFields>;
  currentPortfolio: { portfolioId: string; productId: string; portfolioName: string } = {
    portfolioId: '',
    productId: '',
    portfolioName: '',
  };

  private setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  private setIsFileUploadReset(status: boolean): void {
    this.isFileUploadReset = status;
  }

  public openUploadModal(portfolioId: string, portfolioName: string, productId: string): void {
    this.setIsFileUploadReset(false);
    this.currentPortfolio = { portfolioId, portfolioName, productId };
    this.showUploadFileModal = true;
  }

  public closeUploadModal(): void {
    this.showUploadFileModal = false;
    this.uploadFileForm.resetForm();
    this.setIsFileUploadReset(true);
  }

  public async uploadDocument(uploadedFile: AcceptedFiles, cartId: string): Promise<void> {
    this.setLoading(true);
    const uploadedFileName = Object.keys(uploadedFile)[0];

    const res = await addCollateral(
      cartId,
      this.currentPortfolio.portfolioId,
      this.currentPortfolio.productId,
      uploadedFileName,
      this.uploadFileForm.fields.name.value,
    );
    await runInAction(async () => {
      const fileUrl = res?.data?.addCollateral || '';
      await uploadFiles(uploadedFile, { [uploadedFileName]: fileUrl }, (): void => {
        this.setLoading(false);
      });
    });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.uploadFileForm = new FormController({
      name: new FormControl<string>('', { validations: ['printableCharacters'], trim: true }),
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
